import { FieldArray, useFormikContext } from 'formik';
import Spacer from '@antimatterhq/ui/components/spacer';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { FlagSet } from '@antimatterhq/ui/utils/flags';
import { Section } from '@/components/container/section/Section';
import { SilverDataSourceSchemaValues } from '@/zod/schemas/dataSource/Silver';
import { ModifyTable } from '@/components/dataSources/modifyTable/ModifyTable';
import { TocWrapper } from '@/components/tableOfContents/ToCWrapper';
import { useConfigDataSource } from '@/contexts/ConfigDataSourceContext';
import { filterNulls } from '@/utils/filterNulls';
import { SilverDataPreviewContainer } from '@/components/dataSources/dataPreviewContainer/silver/SilverDataPreviewContainer';

export const SilverModifyTables = () => {
  const formik = useFormikContext<SilverDataSourceSchemaValues>();
  const { enableDatasourcePreview } = useFlags<FlagSet>();

  const { values } = formik;

  const { preset } = useConfigDataSource();

  return (
    <div>
      <FieldArray name="modifyTables">
        {() => {
          return (
            <>
              {!!values.modifyTables.length && <Spacer size="lg" />}

              {values.modifyTables.map((modifyTable, index) => {
                const prefix = `modifyTables.${index}.`;
                return (
                  <div key={prefix}>
                    <TocWrapper
                      name={`modifyTables.${index}`}
                      displayName={modifyTable.name}
                    >
                      {!!index && <Spacer size="lg" />}
                      <Section className="relative">
                        <div className="absolute right-5 top-5">
                          {enableDatasourcePreview && (
                            <SilverDataPreviewContainer
                              tableIndex={index}
                              isModifyTable
                            />
                          )}
                        </div>
                        <ModifyTable
                          index={index}
                          currentTable="silver"
                          previousTable="bronze"
                          table={modifyTable}
                          enableClustering={true}
                          presetTables={filterNulls(preset?.silver?.transform)}
                        />
                      </Section>
                      <Spacer size="lg" />
                    </TocWrapper>
                  </div>
                );
              })}
            </>
          );
        }}
      </FieldArray>
    </div>
  );
};
